const COLORS = {
  berry: "var(--color-primitive-pink-500)",
  violet: "var(--color-primitive-violet-500)",
  indigo: "var(--color-primitive-indigo-500)",
  cobalt: "var(--color-primitive-blue-500)",
};

/** Route-specific stop positions, with colours supplied by the design tokens. */
export function getGradientForRoute(path: string): string {
  if (path.includes("/scenes") || path.includes("/workflows")) {
    // Berry prominent
    return `linear-gradient(90deg, ${COLORS.berry} 0%, ${COLORS.berry} 40%, ${COLORS.violet} 65%, ${COLORS.indigo} 85%, ${COLORS.cobalt} 100%)`;
  }
  if (path.includes("/cast")) {
    // Violet prominent
    return `linear-gradient(90deg, ${COLORS.berry} 0%, ${COLORS.violet} 20%, ${COLORS.violet} 55%, ${COLORS.indigo} 80%, ${COLORS.cobalt} 100%)`;
  }
  if (path.includes("/assets")) {
    // Indigo prominent
    return `linear-gradient(90deg, ${COLORS.berry} 0%, ${COLORS.violet} 15%, ${COLORS.indigo} 35%, ${COLORS.indigo} 70%, ${COLORS.cobalt} 100%)`;
  }
  if (path.includes("/library")) {
    // Cobalt prominent
    return `linear-gradient(90deg, ${COLORS.berry} 0%, ${COLORS.violet} 15%, ${COLORS.indigo} 35%, ${COLORS.cobalt} 55%, ${COLORS.cobalt} 100%)`;
  }
  // Default/settings - even distribution
  return `linear-gradient(90deg, ${COLORS.berry} 0%, ${COLORS.violet} 33%, ${COLORS.indigo} 66%, ${COLORS.cobalt} 100%)`;
}
